import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import React from 'react'
import PatternBonusHeader from './patternBonusHeader'
import { IGatsbyImageDataArray } from '@et/types/ImageTypes'
import { GatsbyImage } from 'gatsby-plugin-image'
interface Props {
  images?:
  {
    src: IGatsbyImageDataObject
    alt: string
  }[]
}
function PatternBonus2(props: Props) {

  const { images } = props
  return (
    <div className='py-12 et-grid-basic lg:py-20 bg-cream-200'>

      {/* header */}
      <PatternBonusHeader
        subTitle='Bonus Module 2'
        title='Creating Simple Pattern Mockups in Procreate'
      />

      {/* IMAGES */}
      {images && <div className='col-span-2 col-start-2 md:col-start-2 md:col-span-12 lg:col-start-3 lg:col-span-10 xl:row-start-2 xl:col-start-2 xl:col-span-6 xl:flex xl:items-center xl:ml-[-25px] xxl:ml-[-100px]'>

        <div className='grid grid-cols-3 py-4 gap-x-3 md:gap-x-6 xl:flex-1'>
          {images.map((image, index) => {
            return (
              <div key={index} className='mb-4 shadow-xl'>
                <GatsbyImage image={image.src.gatsbyImageData} alt={`Bonus Module 2: ${image.alt}`} />
              </div>
            )
          })}
        </div>

      </div>}

      {/* CONTENT */}
      <div className='col-span-2 col-start-2 md:col-start-4 md:col-span-8 lg:col-start-4 lg:col-span-8 xl:row-start-2 xl:col-start-8 xl:col-span-6 xl:pl-12 xxl:mr-[-50px]'>
        <p className='mb-4 text-lg lg:text-xl'>Did you know you can open most Photoshop files within Procreate? In this bonus module, I'll show you how to first download then open that Photoshop file in Procreate. Next, we'll start dissecting how it works so we can use it with our patterns. This module includes 2 different Photoshop mockup file tutorials which you can use to preview your patterns on real products.</p>

        <p className='mb-4 text-lg lg:text-xl'>And if Photoshop files aren't your jam, no problem! I also share how to convert any stock photo into a Procreate mockup file from scratch (some advanced Procreate tips in that one ;)</p>

      </div>


    </div>
  )
}

export default PatternBonus2